import { render, staticRenderFns } from "./NavComonents.vue?vue&type=template&id=2464cbc6&scoped=true"
import script from "./NavComonents.vue?vue&type=script&lang=js"
export * from "./NavComonents.vue?vue&type=script&lang=js"
import style0 from "./NavComonents.vue?vue&type=style&index=0&id=2464cbc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2464cbc6",
  null
  
)

export default component.exports